module.exports = __webpack_public_path__ + "img/title-1.e95a8462.png";